import { CallEvent } from '@modules/SoftPhoneModule/types';
import TasksModule from '@modules/TasksModule';
import { InboxContext } from '../types';
import { TaskState } from '@modules/TasksModule/types';
import { setOutboundCallToRejected } from '../callHandlers/outboundCalls';
import { setCallToAbandoned } from '../callHandlers/callStateHandler';
import InboxModule from '..';

function handleCallMissed(_context: InboxContext, event: CallEvent) {
  // if this is an inbound internal call, then we should mark
  // the task as abandoned

  const taskId = event.pcsConversationSid || event.callId;
  const task = TasksModule.getTask(taskId);

  if (!task || task.state !== TaskState.Offered) {
    return;
  }

  if (task.isOutbound) {
    // if this is an outbound call, then we should mark the task as Rejected
    setOutboundCallToRejected(_context, task.id);
  } else if (!InboxModule.hasSession(task)) {
    // if it does not have a session then it will be handled by this handler.
    // if it does have a session, then it will be handled by the SessionDeleted handler.
    setCallToAbandoned({
      context: _context,
      sessionSid: taskId,
      eventType: 'call-missed',
    });
  }
}

export default handleCallMissed;
